interface IUseGetLastSeenLocationProps {
    area: string | undefined;
    layer: string | undefined;
}

export default function useGetLastSeenLocation({ area, layer }: Readonly<IUseGetLastSeenLocationProps>) {
    const lastSeenLocation = area || layer;
    return lastSeenLocation;
}
